import React from 'react';
import PropTypes from 'prop-types';
import Wrapper from '../Wrapper';
import baseStyles from '../../../styles/baseStyles.module.scss';
import RegistrationForm from '../RegistrationForm';
import { ProPageStrings } from '../../../application/javascripts/react_components/mixins/shared/string_constants_mixin';

const getText = isProPage => {
  const { registrationText, loginForm, formText, altLoginsText } = ProPageStrings;
  let text = {
    ...registrationText,
    ...loginForm,
    ...formText,
    ...altLoginsText
  };

  if (isProPage) {
    text = { ...text, ...ProPageStrings };
  }

  return text;
};

const FormFooter = ({ text }) => {
  return (
    <div className={baseStyles.info}>
      {text.privacyPolicyLead}{' '}
      <a className={baseStyles.route} href="/terms">
        {text.termsLink}
      </a>{' '}
      {text.and}{' '}
      <a className={baseStyles.route} href="/privacy">
        {text.privacy}
      </a>
      .
    </div>
  );
};
const SignUpForm = ({
  isProPage,
  locale,
  inUnitedStates,
  handleRegistrationSuccess,
  redirectTo,
  handleLoginClick,
  facebookAppId,
  googleClientId
}) => {
  const text = getText(isProPage);
  const formFooter = <FormFooter text={text} />;

  return (
    <Wrapper text={text} foot={formFooter}>
      <RegistrationForm
        text={text}
        locale={locale}
        userEmailSubscribed={inUnitedStates}
        showEmailSubscribed={!inUnitedStates}
        handleRegistrationSuccess={handleRegistrationSuccess}
        handleLoginClick={handleLoginClick}
        facebookAppId={facebookAppId}
        googleClientId={googleClientId}
        redirectTo={redirectTo}
      />
    </Wrapper>
  );
};

SignUpForm.propTypes = {
  isProPage: PropTypes.bool,
  locale: PropTypes.string,
  inUnitedStates: PropTypes.bool,
  handleRegistrationSuccess: PropTypes.func,
  redirectTo: PropTypes.string,
  handleLoginClick: PropTypes.func,
  facebookAppId: PropTypes.number.isRequired,
  googleClientId: PropTypes.string.isRequired
};

SignUpForm.defaultProps = {
  isProPage: false,
  handleRegistrationSuccess: () => {},
  handleLoginClick: null,
  locale: null,
  inUnitedStates: null,
  redirectTo: null
};

FormFooter.propTypes = {
  text: PropTypes.shape({
    privacyPolicyLead: PropTypes.string,
    termsLink: PropTypes.string,
    privacy: PropTypes.string
  })
};

FormFooter.defaultProps = {
  text: {
    privacyPolicyLead: 'Privacy Policy',
    termsLink: '/terms',
    privacy: 'Privacy'
  }
};

export default SignUpForm;
